import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { F1IssuersExclusionCard } from "./card";
import { F1IssuersExclusionNew } from "./new";
import { F1IssuersExclusionTable } from "./table";
import { setDocumentTitle } from "@/lib/documentTitle";

export default function F1IssuersExclusion() {
  useEffect(() => {
    setDocumentTitle("Quantilia | F1 Issuers Exclusion");
  }, []);

  return (
    <Routes>
      <Route index element={<F1IssuersExclusionTable />} />
      <Route path="new" element={<F1IssuersExclusionNew />} />
      <Route path=":id" element={<F1IssuersExclusionCard />} />
    </Routes>
  );
}
